import { render } from "./ZuschussPerioden.pug?vue&type=template&id=c50b3944&lang=pug"
import script from "./ZuschussPerioden.js?vue&type=script&lang=js"
export * from "./ZuschussPerioden.js?vue&type=script&lang=js"

import "./ZuschussPerioden.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__